import Box from "@mui/material/Box";
import Logger from "../../services/Logger";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getColumns } from "./getColumns";

export default function BoilerplateDataGrid() {
    const navigate = useNavigate();

    const [pageModel, setPageModel] = useState({ page: 0, pageSize: 15 });
    const [sort, setSort] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        // Logger.log("uef in BoilerplateDataGrid");

        setRows([
            { id: 1, level: "abc" },
            { id: 2, level: "def" },
        ]);
    }, [pageModel, sort]);

    const handleCell = (cell) => {
        // Logger.log(cell);
    };

    const handleSort = (model) => {
        setSort(model);
    };

    const handleSelectionModel = (model) => {
        // do something
    };

    return (
        <Box sx={{ flexGrow: 1, height: "50%" }}>
            <DataGrid
                rows={rows}
                columns={getColumns()}
                rowCount={rowCount}
                pageSizeOptions={[15, 25, 30]}
                paginationMode="server"
                sortingMode="server"
                pagination={true}
                paginationModel={pageModel}
                onPaginationModelChange={(m) => setPageModel(m)}
                checkboxSelection
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: false }}
                onCellClick={handleCell}
                onSortModelChange={handleSort}
                onSelectionModelChange={handleSelectionModel}
                columnVisibilityModel={{ id: false }}
                autoHeight={true}
                hideFooterSelectedRowCount
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
                disableRowSelectionOnClick
            />
        </Box>
    );
}
